import Icon from '@mdi/react';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import DynamicTreeItem, { labelTextStyles } from '../../../General/DynamicTree/DynamicTreeItem';
import { IProjectContextMenuConfig } from './ProjectContextMenu';
import ProjectFavouriteButton from './ProjectFavouriteButton';
import ProjectRowTag from './ProjectRowTag';
import { IUserProjectModuleData } from '../../../../redux/user/sliceUserProjects';
import i18n from '../../../../localization/i18n';
import { TreeItemProps } from '@mui/x-tree-view';

/**
 * TreeItem for showing a project.
 */
export const TreeItemProject = (props: ITreeItemProjectProps) => {
    /** Deconstruct values from props. */
    const {
        labelIcon,
        labelText,
        favourite,
        module,
        contextMenuConfig,
        /** All other values are stored in 'other'. */
        ...other
    } = props;

    /** Label Component. */
    const itemLabel = (
        <Stack
            direction='row'
            spacing={1}
            onContextMenu={contextMenuConfig.callback}
            sx={{
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    color: 'inherit',
                }}
            >
                {labelIcon && <Icon path={labelIcon} size={1} />}
            </Box>

            <Typography variant='body2' sx={labelTextStyles(1)}>
                {labelText}
            </Typography>

            {module && (
                <>
                    <ProjectRowTag
                        moduleAbbreviation={module.moduleAbbreviation}
                        tagColor={module.tagColor}
                        tooltipTitle={module.translations[i18n.language]}
                    />
                    <ProjectFavouriteButton replicaId={props.itemId} favourite={favourite} />
                </>
            )}
        </Stack>
    );

    return <DynamicTreeItem label={itemLabel} {...other} />;
};

/**
 * Interface that describes the properties for a TreeItemProject.
 */
export interface ITreeItemProjectProps extends TreeItemProps {
    /** (Optional) TreeItem Icon. */
    labelIcon?: string;

    /** TreeItem title text. */
    labelText: string;

    /** (Optional) Project favourite status. */
    favourite?: boolean;

    /** Project module data. */
    module?: IUserProjectModuleData;

    /** Context Menu Configuration. */
    contextMenuConfig: IProjectContextMenuConfig;
}
